import { JsonObject, JsonProperty } from 'json2typescript';
import { HvlQueryModel, Required } from '@hvlng/framework-bff/core';
import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { HrCommonConstants } from 'humanresources-common-shared';

@JsonObject('KovanHrObjectHierarchyQueryModel')
export class ObjectHierarchyQueryModel extends HvlQueryModel {
    @Required()
    @JsonProperty('objectDefinitionId', Number, true)
    objectDefinitionId: number = null;

    @Required()
    @JsonProperty('beginDate', HvlDateConverter, true)
    beginDate: Date = null;

    @Required()
    @JsonProperty('endDate', HvlDateConverter, true)
    endDate: Date = null;

    @Required()
    @JsonProperty('perPeopleId', Number, true)
    perPeopleId: number = null;

}
